<template>
    <div class="model-el-group">
        <el-form ref="editor" inline label-width="90px">
            <el-form-item label="手机号：">
                <el-input type="text" v-model.number="form.phone" style="width: 150px;" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="分数：">
                <el-input type="text" v-model.number="form.nscore" style="width: 150px;" placeholder="请输入分数"></el-input>
            </el-form-item>
            <el-form-item label="及格：">
                <el-select size="medium" v-model="form.isPass" style="width:150px;" placeholder="是否及格">
                    <el-option :value="1" label="是"></el-option>
                    <el-option :value="0" label="否"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交卷时间：">
                <el-date-picker
                    size="medium"
                    v-model="form.pickerTime"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-form-item>
        </el-form>
        
        <el-table
            :stripe="true"
            v-loading="loading"
            :data="tableData"
            style="width: 100%"
            height="580"
        >
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column prop="nscore" label="分数"></el-table-column>
            <el-table-column label="及格">
                <template slot-scope="scope">
                    <span>{{scope.row.isPass?'是':'否'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="ddateHandIn" label="交卷时间"></el-table-column>
            <!-- <el-table-column label="操作">
                <template slot-scope="scope">
                    <div class="btn-groups">
                        <el-popconfirm
                            icon="el-icon-info"
                            icon-color="red"
                            title="确定要删除此考生成绩吗？"
                            @confirm="deleteRow(scope.row)"
                        >
                            <el-button slot="reference" type="danger" size="mini">删除</el-button>
                        </el-popconfirm>
                    </div>
                </template>
            </el-table-column> -->
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import {
    examResoultList,            //获取列表
    examResoultDel,             //删除
} from "@/service/examination";
export default {
    data() {
        return {
            loading: false,
            form: {
                pageNum: 1,
                pageSize: 10,
                rational: true,

                spaperNo: '',                   //编码号

                phone: '',                      //手机号
                npaperAttribute: '',            //1=认证 2=课程
                isPass: '',                     //0=不及格 1=及格
                nscore: '',                     //分数
                spaperName: '',                 //试卷名称
                pickerTime: [],                 //交卷时间
            },
            searchData:{},
            total: 0,                       //总条数

            tableData: [],
        }
    },
    methods: {
        go(data){
            this.form.npaperAttribute = data.npaperAttribute
            this.form.spaperName = data.spaperName
            this.form.spaperNo = data.spaperNo
            this.form.phone = '';
            this.form.isPass = '';
            this.form.nscore = '';
            this.form.pickerTime = '';
            this.handleSearch();
        },
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleReset() {
            this.form.phone = '';
            this.form.isPass = '';
            this.form.nscore = '';
            this.form.pickerTime = '';
            this.handleSearch()
        },
        async getList(){
            this.loading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.spaperNo  && delete data.spaperNo
            !data.phone && delete data.phone
            !data.npaperAttribute && delete data.npaperAttribute
            data.isPass === '' && delete data.isPass
            !data.nscore && delete data.nscore
            !data.spaperName && delete data.spaperName
            if (data.pickerTime && data.pickerTime.length) {
                data.ddateHandInBegin = data.pickerTime[0] + ' 00:00:01'
                data.ddateHandInEnd = data.pickerTime[1] + ' 23:59:59'
            }
            delete data.pickerTime
            let res = await examResoultList(data)
            this.loading = false
            this.tableData = res.Data.datas
            this.total = res.Data.total
        },
        handleSizeChange(val) {
            if (this.loading) return
            this.form.pageNum = 1
            this.form.pageSize = val
            this.searchData.pageNum = 1
            this.searchData.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            if (this.loading) return
            this.form.pageNum = val
            this.searchData.pageNum = val
            this.getList()
        },
        deleteRow(rows) {
            examResoultDel({pkid:rows.pkid}).then(res=> {
                if(res.Result !=1 || !res.Data) {
                    return this.$message.error('删除失败！')
                }
                this.$message.success('删除成功！')
                this.handleSearch();
            })
        }
        
    }
}
</script>